export const orderMap: Record<string, number> = {
  Backend: 0,
  Frontend: 1,
  Mobile: 2,
  DevOps: 3,
  General: 4,
};

export const colorMap: Record<string, string> = {
  Frontend: '#0BA5EC',
  Backend: '#0BA5EC',
  Mobile: '#0BA5EC',
  DevOps: '#0BA5EC',
  NotSet: '#6B7280',
  Junior: '#22C55E',
  Middle: '#F59E0B',
  Senior: '#EF4444',
};
